<template>
  <div id="terminal" class="console"></div>
</template>
<script>
import Terminal from './Xterm'
export default {
  name: 'Console',
  props: {
    id: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      term: null,
      terminalSocket: null
    }
  },
  mounted() {
    //this.initTerminal()
  },
  beforeDestroy() {
    this.terminalSocket.close()
    this.term.destroy()
  },
  methods: {
    initTerminal() {
      var containerWidth = window.screen.height
      var containerHeight = window.screen.width
      var token = 'Bearer ' + localStorage.getItem('cbaas_system_Token')
      const isProduction = process.env.NODE_ENV === 'production'
      var prodUrl =
        this.g_Config.WEB_SOCKET_URL +
        '/v1/nodeManagement/webTerminal' +
        '?' +
        'id=' +
        this.id +
        '&token=' +
        token
      var devUrl =
        'ws://' +
        location.hostname +
        ':' +
        location.port +
        '/v1/nodeManagement/webTerminal' +
        '?' +
        'id=' +
        this.id +
        '&token=' +
        token
      var url = isProduction ? prodUrl : devUrl
      var terminalContainer = document.getElementById('terminal')
      this.term = new Terminal()
      this.term.open(terminalContainer)
      // open websocket
      this.terminalSocket = new WebSocket(url)
      this.terminalSocket.onopen = this.runRealTerminal
      this.terminalSocket.onclose = this.closeRealTerminal
      this.terminalSocket.onerror = this.errorRealTerminal
      this.term.attach(this.terminalSocket)
      this.term._initialized = true
    },
    runRealTerminal() {
      console.log('webSocket is finished')
    },
    errorRealTerminal() {
      console.log('error')
    },
    closeRealTerminal() {
      console.log('close')
      this.terminalSocket.close()
      this.term.destroy()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.console {
  @include adaptation((
    --xterm-screen-height: 700px
  ));
  &#terminal {

    /deep/ .xterm .xterm-viewport {
      overflow-y: auto;
    }
    .xterm-screen {
      height: var(--xterm-screen-height) !important;
    }
  }
}
</style>
